import SecureLS from 'secure-ls';

const isBlank = function (value) {
    //Can't use isNaN so turned off the warning
    /* eslint use-isnan: "off"*/
    return value === undefined || value === null || value.toString().trim() === "" || value === NaN || value.toString() === 'NaN'
}

const arraysEqual = function(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.

    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

// Users allowed to view and manage client scripts and script templates.
// This only hides the UI; the API enforces the same list.
const SCRIPT_ADMIN_EMAILS = ['ryan@jeonsoft.com', 'marvin@jeonsoft.com']

const isScriptAdmin = function () {
    try {
        const secureLS = new SecureLS({ encodingType: 'aes', encryptionSecret: process.env.AES_KEY });
        const email = secureLS.get('cloud_license.email');
        return !isBlank(email) && SCRIPT_ADMIN_EMAILS.indexOf(email.toString().trim().toLowerCase()) !== -1
    }
    catch (e) {
        return false
    }
}

export {isBlank, arraysEqual, isScriptAdmin}
